import { render } from "./App.vue?vue&type=template&id=0a0cb8d9&ts=true"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&id=0a0cb8d9&lang=scss"

import exportComponent from "D:\\vue_workspace\\gokou-project\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__